import {useContext} from "../../_snowpack/pkg/react.js";
import useSWR from "../../_snowpack/pkg/swr.js";
import {SettingsContext} from "../App.js";
const fetcher = (url) => fetch(url).then((res) => res.json());
const baseUrl = "https://amiiboapi.com/api";
const useAutocomplete = (character) => {
  const url = `${baseUrl}/character/`;
  const {data} = useSWR(url, fetcher);
  let characters = data?.amiibo.map(({name}) => name).filter((name) => name.toLowerCase().includes(character.toLowerCase()));
  characters = [...new Set(characters)];
  return character !== "" ? characters.slice(0, 5) : [];
};
const useAmiiboSearch = (character) => {
  const [settings] = useContext(SettingsContext);
  const url = `${baseUrl}/amiibo/`;
  const {data, error} = useSWR(`${url}?type=${settings.amiiboType ?? "figure"}${character !== "" ? `&character=${character}` : ""}`);
  return {
    data,
    error,
    isLoading: !data && !error
  };
};
export {useAutocomplete, useAmiiboSearch};
